import { useActor } from '@xstate/react';
import * as React from 'react';
import { useLoginMachine } from './useLoginMachine';

const LoginMachineServiceContext = React.createContext<
  ReturnType<typeof useLoginMachine>[2] | undefined
>(undefined);

export const LoginMachineServiceProvider = LoginMachineServiceContext.Provider;

export const useLoginMachineService = () => {
  const loginMachineService = React.useContext(LoginMachineServiceContext);

  if (!loginMachineService) {
    throw new Error(
      'useLoginMachineService must be use within a LoginMachineServiceProvider'
    );
  }

  return useActor(loginMachineService);
};
